import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { InlineAuthForms, InlineAuthFormsProps } from './InlineAuthForms';

interface PhoneAuthFlowProps {
    isAuthStageActive: boolean;
    title: string;
    subtitle: string | undefined;
    authFormsProps: InlineAuthFormsProps;
}

export const PhoneAuthFlow: React.FC<PhoneAuthFlowProps> = ({
    isAuthStageActive,
    title,
    subtitle,
    authFormsProps
}) => {
    const theme = useTheme();

    if (!isAuthStageActive) {
        return null;
    }

    return (
        <Box px={2} py={2}>
            <Typography
                align="center"
                variant="h6"
                sx={{ fontWeight: theme.typography.fontWeightBold, color: 'text.primary', pb: 1 }}
            >
                {title}
            </Typography>
            {subtitle && (
                <Typography align="center" variant="body2" sx={{ color: 'text.secondary', pb: 1 }}>
                    {subtitle}
                </Typography>
            )}
            <InlineAuthForms {...authFormsProps} />
        </Box>
    );
};
